import styled from 'styled-components';
import { Dropdown } from '@fluentui/react';

export const DropdownStyle = styled(Dropdown)`
  .ms-Dropdown-title {
    border: none;
    color: ${(props) => props.theme.textMainColor};
    background: ${(props) => props.theme.popupInputMainBackground};
  }
  #vacationType-option {
    &:hover,
    &:focus,
    &:active {
      color: ${(props) => props.theme.textMainColor};
    }
  }

  [class*='caretDownWrapper-'] {
    i {
      color: ${(props) => props.theme.textMainColor} !important;
    }
  }

  #vacationType-option {
    padding: 0 0.5rem;
  }

  background: #ffffff;
  box-shadow:
    0px 0.6px 1.8px rgba(0, 0, 0, 0.11),
    0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
  border-radius: 4px;
`;

export const VacationTypeContainer = styled.div`
  height: 4.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const VacationTypeLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};

  .required {
    color: red;
  }

  @media (max-width: 710px) {
    font-size: 18px;
  }
`;
